import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { FeedbackGateProvider } from "@/components/FeedbackGate";
import { TycGate } from "@/components/TycGate";
import LandingPage from "@/pages/LandingPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import ToolsIndexPage from "@/pages/ToolsIndexPage";
import LegajosPage from "@/pages/LegajosPage";
import CalculatorPage from "@/pages/CalculatorPage";
import SueldosPage from "@/pages/SueldosPage";
import ListaPage from "@/pages/ListaPage";
import ReceiptsPage from "@/pages/ReceiptsPage";
import LegislacionPage from "@/pages/LegislacionPage";
import AdminPage from "@/pages/AdminPage";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to={adminOnly ? "/admin/login" : "/registro"} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <FeedbackGateProvider>
              <TycGate />
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/registro" element={<RegisterPage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/app" element={<Protected><ToolsIndexPage /></Protected>} />
                <Route path="/app/legajos" element={<Protected><LegajosPage /></Protected>} />
                <Route path="/app/calculadora" element={<Protected><CalculatorPage /></Protected>} />
                <Route path="/app/calculadora/:calcId" element={<Protected><CalculatorPage /></Protected>} />
                <Route path="/app/sueldos" element={<Protected><SueldosPage /></Protected>} />
                <Route path="/app/lista" element={<Protected><ListaPage /></Protected>} />
                <Route path="/app/sueldos-lista" element={<Navigate to="/app/lista" replace />} />
                <Route path="/app/aguinaldo-lista" element={<Navigate to="/app/lista" replace />} />
                <Route path="/app/recibos" element={<Protected><ReceiptsPage /></Protected>} />
                <Route path="/app/recibos-sueldos" element={<Navigate to="/app/recibos" replace />} />
                <Route path="/app/legislacion" element={<Protected><LegislacionPage /></Protected>} />
                <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </FeedbackGateProvider>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
